import React, { useEffect, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { refreshTokenApiCall } from 'redux/actions/auth';
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';

function RefreshTokenHOC() {
  const history = useHistory();
  const dispatch = useDispatch();
  const storedData = useSelector((state) => state.storedData.payload);
  const tokenRef = useRef(localStorage.getItem('token'));
  const refreshTokenRef = useRef(localStorage.getItem('refreshToken'));
  const lastActiveTimeRef = useRef(new Date().valueOf());
  const inactivityTimeoutRef = useRef(null);

  const handleUserActivity = () => {
    const date = new Date();
    lastActiveTimeRef.current = date.valueOf();

    // Clear the previous timeout and set a new one
    if (inactivityTimeoutRef.current) {
      clearTimeout(inactivityTimeoutRef.current);
    }
    inactivityTimeoutRef.current = setTimeout(() => {
      handleLogout()
    }, 2700000); // 45 minutes
  };

  useEffect(() => {
    handleUserActivity(); // Initialize on component mount
    checkTokenExpiration(tokenRef.current, refreshTokenRef.current);
    window.addEventListener('keydown', handleUserActivity);
    window.addEventListener('mousedown', handleUserActivity);
    window.addEventListener('touchstart', handleUserActivity);

    return () => {
      window.removeEventListener('keydown', handleUserActivity);
      window.removeEventListener('mousedown', handleUserActivity);
      window.removeEventListener('touchstart', handleUserActivity);
    };
  }, []);

  const checkTokenExpiration = async (token, refreshTokenTemp) => {
    // const response = await dispatch(refreshTokenApiCall(refreshTokenTemp, token));
    // if (response.statusCode === 401) {
    //   handleLogout();
    //   return;
    // }

    const expirationTime = localStorage.getItem('ptTokenExpiration');
    const currentTime = new Date().valueOf();
    if (expirationTime && currentTime > parseInt(expirationTime, 10)) {
      handleLogout();
    } else {
      handleUserActivity();
    }
  };

  const handleLogout = () => {
    dispatch(logoutAdmin());
    dispatch(logoutClearRedux());
    localStorage.clear();
    sessionStorage.clear();
    history.push('/sign-in');
  };

  useEffect(() => {
    const intervalCall = setInterval(() => {
      const date = new Date();
      const currentTime = date.valueOf();
      const activityTimeGap = currentTime - lastActiveTimeRef.current;
      if (activityTimeGap < 2700000) { // less than 45 minutes
        refreshTokenFunction(tokenRef.current, refreshTokenRef.current);
      } else {
        handleLogout();
      }
    }, 120000); // 2 minutes
    return () => clearInterval(intervalCall);
  }, [history]);

  const refreshTokenFunction = async (token, refreshTokenTemp) => {
    const response = await dispatch(refreshTokenApiCall(refreshTokenTemp, token));
    if (response?.body?.payload?.refreshToken) {
      const newToken = response?.body?.payload?.token;
      const newRefreshToken = response?.body?.payload?.refreshToken;
      const expirationTime = new Date().getTime() + 9 * 60 * 1000; // 9 minutes from now

      localStorage.setItem('token', newToken);
      localStorage.setItem('refreshToken', newRefreshToken);
      localStorage.setItem('ptTokenExpiration', expirationTime);

      tokenRef.current = newToken;
      refreshTokenRef.current = newRefreshToken;

      let obj = { ...storedData, token: newToken, refreshToken: newRefreshToken };
      dispatch({ type: 'LOCAL_STORE_DATA', payload: obj });
    } else if (response.statusCode === 401) {
      handleLogout();
    }
  };

  return null;
}

export default RefreshTokenHOC;